import type { ICreateVisitNoteRequest } from "../../../core/ports/driver/VisitNotesService";

export const buildCreateVisitNotePayload = (
  request: ICreateVisitNoteRequest
): Record<string, unknown> => ({
  clinic_id: request.clinic_id,
  patient_id: request.patient_id,
  doc_type: request.doc_type,
  type: request.type,
  notes: request.notes,
  ...(request.hh_visit_phase !== undefined && {
    hh_visit_phase: request.hh_visit_phase,
  }),
  ...(request.hh_visit_assignment_id !== undefined && {
    hh_visit_assignment_id: request.hh_visit_assignment_id,
  }),
  ...(request.doc_type === "third_party_np_visit" &&
    request.visit_group !== undefined && {
      visit_group: request.visit_group,
    }),
  ...(request.doc_type === "third_party_np_visit" &&
    request.visit_type !== undefined && {
      visit_type: request.visit_type,
    }),
  file_link: request.file_link,
  total_time: request.total_time,
  context: request.context,
  ...(request.shortlisted !== undefined && {
    shortlisted: request.shortlisted,
  }),
  ...(request.created_at && {
    created_at: request.created_at,
  }),
  ...(request.client_request_id !== undefined && {
    client_request_id: request.client_request_id,
  }),
  ...(request.custom_todo_id !== undefined && {
    custom_todo_id: request.custom_todo_id,
  }),
  ...(request.hh_follow_up_todo_id !== undefined && {
    hh_follow_up_todo_id: request.hh_follow_up_todo_id,
  }),
  ...(request.hh_at_risk_trigger !== undefined && {
    hh_at_risk_trigger: request.hh_at_risk_trigger,
  }),
  ...(request.assigned_provider_user_id !== undefined && {
    assigned_provider_user_id: request.assigned_provider_user_id,
  }),
  ...(request.calendar_dispatch !== undefined && {
    calendar_dispatch: request.calendar_dispatch,
  }),
});
